<template>
  <div class="order-customer-detail">
    <div class="order-customer-detail__header-block block-firstname">
      <span class="label">{{ $t('firstname') }}</span>
      <span class="text">{{order.customer_firstname || $t('not-specified')}}</span>
    </div>
    <div class="order-customer-detail__header-block block-lastname">
      <span class="label">{{ $t('lastname') }}</span>
      <span class="text">{{order.customer_lastname || $t('not-specified')}}</span>
    </div>
    <div class="order-customer-detail__header-block block-store-phone">
      <span class="label">{{ $t('phone') }}</span>
      <span class="text">{{ phoneNumber }}</span>
    </div>
    <div class="order-customer-detail__header-block block-email">
      <span class="label">{{ $t('email') }}</span>
      <span class="text">{{ order.customer_email }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderCustomerDetail',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    phoneNumber () {
      if (this.order && Object.keys(this.order.billing_address).length > 0) {
        return this.order.billing_address.telephone || this.$t('not-specified')
      } else {
        return this.$t('not-specified')
      }
    }
  }
}
</script>
